'use strict';

(function (angular) {
  'use strict';

  angular.module('zp').constant('GooglePlacesConfig', getGooglePlacesConfig());

  /** @ngInject */
  function getGooglePlacesConfig() {
    return {
      from: {
        types: ['(cities)'],
        componentRestrictions: { country: "rs" },
        language: 'en'
      },
      to: {
        types: ['(cities)'],
        componentRestrictions: { country: "rs" },
        language: 'en'
      }
    };
  }
})(window.angular);